import { tv } from 'tailwind-variants'

export const buttonGroupVariants = tv({
  base: 'inline-flex flex-row gap-[2px]',
})
